var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2396 0.804352H5.76562V0.809848H0.707081C0.504801 0.809848 0.34082 0.973828 0.34082 1.17611V2.93904C0.34248 3.14063 0.505492 3.30365 0.707081 3.3053L5.76562 3.3053L6.72536 3.3053L15.2396 3.3053C15.4472 3.3053 15.6156 3.13695 15.6156 2.92928V1.17977C15.6156 1.0801 15.576 0.984516 15.5054 0.914094C15.4349 0.843672 15.3392 0.804191 15.2396 0.804352Z",
    className: "color5Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrementIcon);
export default __webpack_public_path__ + "static/media/decrement-icon.a48a92957a2271adc6afef29ebcd3abf.svg";
export { ForwardRef as ReactComponent };